module.exports = __webpack_public_path__ + "static/media/icon_share_instagram.fb16c22a.svg";